import { CrudService } from "../services";

export function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
    }
    return array
}

export function fillOtherLangs(object, field) {
    var default_val = "";
    for (let i = 1; i <= 5; i++) {
        if (object[field + i] != null && object[field + i] != "") {
            default_val = object[field + i];
            break;
        }
    }

    for (let i = 1; i <= 5; i++) {
        if (object[field + i] == null || object[field + i] == "") {
            object[field + i] = default_val;
        }
    }
    return object;
}

export function printScrn(index) {
    let table = index?document.getElementsByClassName("printableArea")[index]:document.getElementsByClassName("printableArea")[0];
    let thead = table.getElementsByTagName("thead")[0];
    let tbody = table.getElementsByTagName("tbody")[0];

    let copy_html = "<table width='100%'><tr>";

    let heads = thead.getElementsByTagName("th");
    for (let i = 0; i < heads.length; i++) {
        if (!heads[i].classList.contains('no-print') && heads[i].innerHTML) {
            copy_html += "<th>" + heads[i].innerHTML + "</th>"
        }
    }
    copy_html += "</tr>";
    let rows = tbody.getElementsByTagName("tr");
    for (let i = 0; i < rows.length; i++) {
        if (!rows[i].classList.contains('no-print')) {
            copy_html += "<tr>";
            let cols = rows[i].getElementsByTagName("td");
            for (let j = 0; j < cols.length; j++) {
                if (!cols[j].classList.contains('no-print')) {
                    copy_html += "<td>" + cols[j].innerHTML + "</td>"
                }
            }
            copy_html += "</tr>";
        }

    }
    copy_html += "</table>";
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

    WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
            <title>  ${document.title}  </title>
            <style>
              .no-print, .no-print * { display: none !important; }
              table {border-collapse: collapse;}
              table, th, td { border: 1px solid black;}
            </style>
        </head>
        <body>
          ${copy_html}
        </body>
      </html>`);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
}

export function buildSqlQuery(widgetFilters, queryRule, templateFields, sqlQuery, setDefault) {
    //console.log("widgetFilters="+JSON.stringify(widgetFilters));
    //console.log("templateFields="+JSON.stringify(templateFields));
    let hiddenConditions = [];
    if (widgetFilters) {
        for (let key in widgetFilters) {
            if (key && key.length) {
                let columnType = 'STRING';
                let controlType = 'INPUT_BOX';
                for (let i = 0; i < templateFields.length; i++) {
                    let field = templateFields[i];
                    if (field['columnType'] && field['columnName'] == key) {
                        columnType = field['columnType'] ? field['columnType'] : 'STRING';
                        controlType = field['controlType'] ? field['controlType'] : 'INPUT_BOX';
                        break;
                    }
                }

                let value = null;
                let org_value = widgetFilters[key];
                //console.log("org_value="+org_value)
                if (columnType.toUpperCase() === 'STRING') {
                    if (controlType.toUpperCase() === 'SELECT_BOX') {
                        if (org_value && org_value.length > 0) {
                            value = org_value.map(function (v) {
                                return "'" + v + "'";
                            }).join(",");
                        }
                    } else {
                        if (org_value && org_value.length > 0) {
                            value =  org_value ;
                        }
                    }

                } else if (columnType.toUpperCase() === 'NUMERIC') {
                    if (controlType.toUpperCase() === 'SELECT_BOX') {
                        if (!isNaN(parseFloat(org_value)) && !isNaN(org_value - 0)) {
                            value = org_value;
                        }
                    } else {
                        if (!isNaN(parseFloat(org_value)) && !isNaN(org_value - 0)) {
                            value = org_value;
                        }
                    }
                } else if (columnType.toUpperCase() === 'BOOLEAN') {
                    if (org_value != null) {
                        value = org_value;
                    }
                } else if (columnType.toUpperCase() === 'DATE') {
                    if (org_value) {
                        if (controlType.toUpperCase() === 'DATE_RANGE_PICKER') {
                            value = org_value.start + "," + org_value.end;
                        } else {
                            if (org_value && org_value.length > 0) {
                                value = org_value;
                            }
                        }
                    }
                }
                if (value != null) {
                    hiddenConditions.push({
                        columnName: key,
                        value: value,
                        columnType: columnType,
                        controlType: controlType
                    });
                }
            }
        }
    }else{

        if(setDefault){
            for (let i = 0; i < templateFields.length; i++) {
                let field = templateFields[i];
               // console.log(field);
                if(field.columnType.toUpperCase() === 'NUMERIC'){
                    hiddenConditions.push({
                        columnName: field.columnName,
                        value: 0,
                        columnType: field.columnType,
                        controlType: 'INPUT_BOX'
                    });
                }else{
                    hiddenConditions.push({
                        columnName: field.columnName,
                        value: '_',
                        columnType: field.columnType,
                        controlType: 'INPUT_BOX'
                    });
                }
            }
        }
    }

    while(sqlQuery.indexOf(":query_rule") != -1) {
        if (queryRule && queryRule.length > 0) {
            sqlQuery = sqlQuery.replace("{:query_rule}", queryRule);
            sqlQuery = sqlQuery.replace(":query_rule", queryRule);
        } else {
            sqlQuery = sqlQuery.replace("{:query_rule}", "");
            sqlQuery = sqlQuery.replace(":query_rule", "");
        }
    }

    //console.log("hiddenConditions="+JSON.stringify(hiddenConditions));

    sqlQuery = sqlQuery.replace(/\{([^\}]*)\}/g, function (match, capture) {
        let hasValue = false;
        let foundQueryCondition;
        if (hiddenConditions.length > 0) {
            for (let i = 0; i < hiddenConditions.length; i++) {
                let queryCondition = hiddenConditions[i];
                if (capture.includes(":" + queryCondition.columnName) && queryCondition.value != null) {
                    hasValue = true;
                    foundQueryCondition = queryCondition;
                    break;
                }
            }
        }
        //console.log("match=" + match)
       // console.log("capture=" + capture)
        if (!hasValue) {
            return "";
        } else {
            let paramName = ":" + foundQueryCondition.columnName;
            if (foundQueryCondition.columnType.toUpperCase() === 'DATE') {
                if (foundQueryCondition.controlType.toUpperCase() === 'DATE_RANGE_PICKER') {
                    capture = capture.replace(paramName + '0', foundQueryCondition.value.start);
                    capture = capture.replace(paramName + '1', foundQueryCondition.value.end);
                } else {
                    capture = capture.replace(paramName, foundQueryCondition.value);
                }
            } else {
                capture = capture.replace(paramName, foundQueryCondition.value);
            }

            return capture;
        }
    });

    return sqlQuery;
}

export function findSearchFields(groupType, templateFields, selectedLocaleIndex) {
    if (templateFields) {
        let fields = [];
        if (templateFields.length > 0) {
            for (let i = 0; i < templateFields.length; i++) {
                let templateField = templateFields[i];
                let will_push = false;

                if(templateField.optionValue.length > 0 && templateField.controlType == 'SELECT_BOX'){
                    var options = templateField.optionValue.split("\n");
                    templateField.optionValueList = [];
                    options.forEach(element => {
                        if(element == "")return;
                         var option = JSON.parse(element);    
                         templateField.optionValueList.push(option);
                    });
                    
                }

                if (groupType === 'QUERY_BUILDER') {
                    if (templateField.groupType === 'QUERY_BUILDER') {
                        will_push = true;
                    }
                } else {
                    if (templateField.groupType !== 'QUERY_BUILDER') {
                        will_push = true;
                    }
                }
                if (will_push) {
                    fields.push({
                        text: templateField['title' + selectedLocaleIndex],
                        value: templateField.columnName,
                        columnType: templateField.columnType,
                        controlType: templateField.controlType,
                        optionValues: templateField.optionValueList,
                        widthClass: templateField.widthClass ? templateField.widthClass : "'lg4 md4 sm6 xs12'",
                        orderValue: templateField.orderValue,
                    });
                }

            }
        }
        fields.sort(function (a, b) {
            return a.orderValue - b.orderValue
        });
        return fields;
    } else {
        return [];
    }
}



export function executeSQLQuery(paging, sqlQuery){
    let paginationData = {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "",
        totalItems: 0,
        rowsPerPageItems: [10, 20],
        paging: paging
    };

    return CrudService.of("dashboard").getList(paginationData, {sqlQuery:sqlQuery},'execute-query').then(data => {
        return data;
    });
}

export function getRenderValueMap(renderValues){
    let renderValueMap = {};
    if(!renderValues){
        return renderValueMap;
    }
    try {
        let renderValueList = JSON.parse(renderValues);
        for(let i=0;i< renderValueList.length; i++){
            let item = renderValueList[i];
            renderValueMap[item.value] = item.text;
        }
    } catch(e) {
        console.log(e);
        renderValueMap = {};
    }
    return renderValueMap;
}


